"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfCoreDocument = instanceOfCoreDocument;
exports.CoreDocumentFromJSON = CoreDocumentFromJSON;
exports.CoreDocumentFromJSONTyped = CoreDocumentFromJSONTyped;
exports.CoreDocumentToJSON = CoreDocumentToJSON;
exports.CoreDocumentToJSONTyped = CoreDocumentToJSONTyped;
var EmbeddedCompetitionEvent_1 = require("./EmbeddedCompetitionEvent");
var NamedIdentifiable_1 = require("./NamedIdentifiable");
var EmbeddedEvent_1 = require("./EmbeddedEvent");
var ReferencedDisplay_1 = require("./ReferencedDisplay");
var EmbeddedCompetitionEntry_1 = require("./EmbeddedCompetitionEntry");
var EmbeddedCompetitionMatch_1 = require("./EmbeddedCompetitionMatch");
var EntityRef_1 = require("./EntityRef");
var IdentifiableDisplay_1 = require("./IdentifiableDisplay");
var StringIconicDisplay_1 = require("./StringIconicDisplay");
var EmbeddedCompetition_1 = require("./EmbeddedCompetition");
/**
 * Check if a given object implements the CoreDocument interface.
 */
function instanceOfCoreDocument(value) {
    return true;
}
function CoreDocumentFromJSON(json) {
    return CoreDocumentFromJSONTyped(json, false);
}
function CoreDocumentFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'reference': json['reference'] == null ? undefined : (0, EntityRef_1.EntityRefFromJSON)(json['reference']),
        'id': json['id'] == null ? undefined : json['id'],
        'dateFinalized': json['dateFinalized'] == null ? undefined : (new Date(json['dateFinalized'])),
        'name': json['name'] == null ? undefined : json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'event': json['event'] == null ? undefined : (0, EmbeddedEvent_1.EmbeddedEventFromJSON)(json['event']),
        'competition': json['competition'] == null ? undefined : (0, EmbeddedCompetition_1.EmbeddedCompetitionFromJSON)(json['competition']),
        'competitionBracket': json['competitionBracket'] == null ? undefined : (0, NamedIdentifiable_1.NamedIdentifiableFromJSON)(json['competitionBracket']),
        'competitionMatch': json['competitionMatch'] == null ? undefined : (0, EmbeddedCompetitionMatch_1.EmbeddedCompetitionMatchFromJSON)(json['competitionMatch']),
        'competitionEntries': json['competitionEntries'] == null ? undefined : (json['competitionEntries'].map(EmbeddedCompetitionEntry_1.EmbeddedCompetitionEntryFromJSON)),
        'competitionEvent': json['competitionEvent'] == null ? undefined : (0, EmbeddedCompetitionEvent_1.EmbeddedCompetitionEventFromJSON)(json['competitionEvent']),
        'game': json['game'] == null ? undefined : (0, StringIconicDisplay_1.StringIconicDisplayFromJSON)(json['game']),
        'communities': json['communities'] == null ? undefined : (json['communities'].map(IdentifiableDisplay_1.IdentifiableDisplayFromJSON)),
        'constituentsMax': json['constituentsMax'] == null ? undefined : json['constituentsMax'],
        'organizer': json['organizer'] == null ? undefined : (0, ReferencedDisplay_1.ReferencedDisplayFromJSON)(json['organizer']),
        'constituentsCount': json['constituentsCount'] == null ? undefined : json['constituentsCount'],
    };
}
function CoreDocumentToJSON(json) {
    return CoreDocumentToJSONTyped(json, false);
}
function CoreDocumentToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'reference': (0, EntityRef_1.EntityRefToJSON)(value['reference']),
        'id': value['id'],
        'dateFinalized': value['dateFinalized'] == null ? undefined : ((value['dateFinalized']).toISOString()),
        'name': value['name'],
        'description': value['description'],
        'event': (0, EmbeddedEvent_1.EmbeddedEventToJSON)(value['event']),
        'competition': (0, EmbeddedCompetition_1.EmbeddedCompetitionToJSON)(value['competition']),
        'competitionBracket': (0, NamedIdentifiable_1.NamedIdentifiableToJSON)(value['competitionBracket']),
        'competitionMatch': (0, EmbeddedCompetitionMatch_1.EmbeddedCompetitionMatchToJSON)(value['competitionMatch']),
        'competitionEntries': value['competitionEntries'] == null ? undefined : (value['competitionEntries'].map(EmbeddedCompetitionEntry_1.EmbeddedCompetitionEntryToJSON)),
        'competitionEvent': (0, EmbeddedCompetitionEvent_1.EmbeddedCompetitionEventToJSON)(value['competitionEvent']),
        'game': (0, StringIconicDisplay_1.StringIconicDisplayToJSON)(value['game']),
        'communities': value['communities'] == null ? undefined : (value['communities'].map(IdentifiableDisplay_1.IdentifiableDisplayToJSON)),
        'constituentsMax': value['constituentsMax'],
        'organizer': (0, ReferencedDisplay_1.ReferencedDisplayToJSON)(value['organizer']),
        'constituentsCount': value['constituentsCount'],
    };
}
